import apiClient from '../helpers/ApiClient'
import { handleError, authHeader } from '../helpers/ApiClient';

export const superUserService = {
    getAllSuperUsers,
    createSuperUser,
    updateSuperUser,
    regeneratePassword,
    deleteSuperUser,
};

function getAllSuperUsers(){
    return apiClient.get("/super-user", { headers: authHeader() })
        .then((response) => {
            return response.data
        })
        .catch((error) => handleError(error));
}

function createSuperUser(payload){
    return apiClient.post("/super-user", payload, { headers: authHeader() })
        .then((response) => {
            return response.data
        })
        .catch((error) => handleError(error));
}

function updateSuperUser(userId, payload){
    return apiClient.patch(`/super-user/${userId}`, payload, { headers: authHeader() })
        .then((response) => {
            return response.data
        })
        .catch((error) => handleError(error));
}

function regeneratePassword(userId){
    return apiClient.post(`/super-user/${userId}/regenerate-password`, {}, { headers: authHeader() })
        .then((response) => {
            return response.data
        })
        .catch((error) => handleError(error));
}

function deleteSuperUser(userId){
    return apiClient.delete(`/super-user/${userId}`, { headers: authHeader() })
        .then((response) => {
            return response.data
        })
        .catch((error) => handleError(error));
}
